import { Ambiente } from '../../types';
import { ElegibilidadeSuporteAosEstudosConfig, Params } from './elegibilidade-suporte-aos-estudos.types';

const configDefault: ElegibilidadeSuporteAosEstudosConfig = {
  periodoMinimo: '2024.2',
  marca: ['wyden', 'estacio'],
  tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
  modalidade: ['TOTAL EAD'],
  codigoCurso: [],
  matricula: [],
  codigoDisciplina: ['DGT3041', 'DGT5423', 'DGT0024', 'DGT0315', 'END0007'],
};

const configDefaultEmpty: ElegibilidadeSuporteAosEstudosConfig = {
  periodoMinimo: undefined,
  marca: undefined,
  tipoCurso: undefined,
  modalidade: undefined,
  codigoCurso: undefined,
  matricula: undefined,
  codigoDisciplina: undefined,
};

const configsPorAmbiente: Record<Ambiente, ElegibilidadeSuporteAosEstudosConfig> = {
  local: configDefault,
  dev: configDefault,
  hml: configDefault,
  prd: configDefaultEmpty,
};

export const getElegibilidadeSuporteAosEstudosConfig = ({ ambiente }: Params): ElegibilidadeSuporteAosEstudosConfig =>
  configsPorAmbiente[ambiente];
